import { ApplicationState, Role, Action } from "./types";
import { PRODUCT_TYPES } from "../applications/config";

type Permissions = {
  [key in Role]?: {
    [key in ApplicationState]?: Action[];
  };
};

// Applicaton State based permissions, defaulting this to
export const CONSUMER_DURABLES_LOAN_PERMISSIONS: Permissions = {
  [Role.SALES_USER]: {
    [ApplicationState.DRAFT]: [
      Action.CREATE_APPLICATION,
      Action.EDIT_APPLICATION,
      Action.SAVE_APPLICATION,
      Action.SUBMIT_APPLICATION,
    ],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.UPLOAD_DOCUMENT,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.INVOICE_COLLECTED,
    ],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
  },
  [Role.BACK_OFFICE_USER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [
      Action.SOFT_APPROVE,
      Action.REQUEST_EDIT_APPLICATION,
    ],
    [ApplicationState.INVOICE_COLLECTED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE,
    ],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION, Action.SIGN],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION, Action.DISBURSE],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.SANCTION,
    ],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
  },
  [Role.SALES_MANAGER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
  [Role.ADMIN]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
};

export const PERSONAL_LOAN_PERMISSIONS: Permissions = {
  [Role.SALES_USER]: {
    [ApplicationState.DRAFT]: [
      Action.CREATE_APPLICATION,
      Action.EDIT_APPLICATION,
      Action.SAVE_APPLICATION,
      Action.SUBMIT_APPLICATION,
    ],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.UPLOAD_DOCUMENT,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
  },
  [Role.BACK_OFFICE_USER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [
      Action.SOFT_APPROVE,
      Action.REQUEST_EDIT_APPLICATION,
    ],
    [ApplicationState.INVOICE_COLLECTED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE,
    ],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION, Action.SIGN],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION, Action.DISBURSE],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.START_VERIFICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION,
      Action.SANCTION,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE
    ],
  },
  [Role.SALES_MANAGER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
  [Role.ADMIN]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
};

export const BUSINESS_LOAN_PERMISSIONS: Permissions = {
  [Role.SALES_USER]: {
    [ApplicationState.DRAFT]: [
      Action.CREATE_APPLICATION,
      Action.EDIT_APPLICATION,
      Action.SAVE_APPLICATION,
      Action.SUBMIT_APPLICATION,
    ],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.UPLOAD_DOCUMENT,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
  },
  [Role.BACK_OFFICE_USER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [
      Action.SOFT_APPROVE,
      Action.REQUEST_EDIT_APPLICATION,
    ],
    [ApplicationState.INVOICE_COLLECTED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE,
    ],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION, Action.SIGN],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION, Action.DISBURSE],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.START_VERIFICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION,
      Action.SANCTION,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE
    ],
  },
  [Role.SALES_MANAGER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
  [Role.ADMIN]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
};

export const GROUP_LOAN_PERMISSIONS: Permissions = {
  [Role.SALES_USER]: {
    [ApplicationState.DRAFT]: [
      Action.CREATE_APPLICATION,
      Action.EDIT_APPLICATION,
      Action.SAVE_APPLICATION,
      Action.SUBMIT_APPLICATION,
    ],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.UPLOAD_DOCUMENT,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION
    ],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
  },
  [Role.BACK_OFFICE_USER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [
      Action.SOFT_APPROVE,
      Action.REQUEST_EDIT_APPLICATION,
    ],
    [ApplicationState.INVOICE_COLLECTED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE,
    ],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION, Action.SIGN],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION, Action.DISBURSE],
    [ApplicationState.DISBURSED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.START_VERIFICATION,
    ],
    [ApplicationState.PENDING_VERIFICATION]: [
      Action.VIEW_APPLICATION,
    ],
    [ApplicationState.VERIFICATION_COMPLETE]: [
      Action.VIEW_APPLICATION,
      Action.SANCTION,
    ],
    [ApplicationState.APPROVED]: [
      Action.VIEW_APPLICATION,
      Action.MANDATE
    ],
  },
  [Role.SALES_MANAGER]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
  [Role.ADMIN]: {
    [ApplicationState.REJECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SUBMITTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.DRAFT]: [Action.VIEW_APPLICATION],
    [ApplicationState.SOFT_APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.APPROVED]: [Action.VIEW_APPLICATION],
    [ApplicationState.INVOICE_COLLECTED]: [Action.VIEW_APPLICATION],
    [ApplicationState.MANDATED]: [Action.VIEW_APPLICATION],
    [ApplicationState.SIGNED]: [Action.VIEW_APPLICATION],
  },
};

export const PRODUCT_TYPE_BASED_PERMISSIONS = {
  [PRODUCT_TYPES.PERSONAL_LOAN]: PERSONAL_LOAN_PERMISSIONS,
  [PRODUCT_TYPES.BUSINESS_LOAN]: BUSINESS_LOAN_PERMISSIONS,
  [PRODUCT_TYPES.CONSUMER_DURABLES_LOAN]: CONSUMER_DURABLES_LOAN_PERMISSIONS,
  [PRODUCT_TYPES.GROUP_LOAN]: GROUP_LOAN_PERMISSIONS
}

// Define default actions based on roles (without considering state of application)
export const DEFAULT_PERMISSIONS: Record<Role, Action[]> = {
  [Role.SALES_USER]: [
    Action.CREATE_APPLICATION,
    Action.EDIT_APPLICATION,
    Action.SUBMIT_APPLICATION,
    Action.INVOICE_COLLECTED,
  ],
  [Role.BACK_OFFICE_USER]: [
    Action.SOFT_APPROVE,
    Action.REQUEST_EDIT_APPLICATION,
    Action.SANCTION,
    Action.MANDATE,
    Action.SIGN,
    Action.DISBURSE,
  ],
  [Role.FIELD_USER]: [],
  [Role.SALES_MANAGER]: [
    Action.VIEW_USER_LOGIN_HISTORY,
    // Temporary
    Action.COPY_PAST_TABLE,
  ],
  [Role.ADMIN]: [
    Action.VIEW_USER_LOGIN_HISTORY,
    // Temporary
    Action.COPY_PAST_TABLE,
  ],
};
